if (!customElements.get('mute-component')) {
  class MuteComponent extends HTMLElement {
    constructor() {
      super();
      this.parentSelector = this.dataset?.parent || '.shopify-section'
    }
    
    connectedCallback() {
      const trigger = this.querySelector(".banner__mute-trigger input")
      let player = this.getClosestPlayer()
      const defferedMedia = this.closest(this.parentSelector).querySelector('deferred-media')

      if (!trigger || (!player && !defferedMedia)) this.hideSection()

      trigger.addEventListener('click', (e) => {
        if (!player && defferedMedia) player = this.getClosestPlayer()

        if (!player) {
          e.preventDefault()
          return
        } 

        if (player.tagName === 'VIDEO') {
          player.muted = !trigger.checked
        } else {
          player.toggleMute()
        }
      })
    }
    
    hideSection () {
      this.classList.add('hidden')
      return
    }

    getClosestPlayer() {
      return this.closest(this.parentSelector).querySelector('video') || this.closest(this.parentSelector).querySelector('video-section')
    }
  }
  customElements.define('mute-component', MuteComponent);
}